export enum ServiceType {
  FINANZIAMENTO,
  PROGETTO,
  PROGETTOINTERVENTO,
  INTERVENTO
}
